<template>
  <ul class="photos-gallery">
    <li v-for="(file, i) of files" :key="i">
      <div class="photos-thumbnail">
        <file-thumbnail :fileId="file._fileId" width="40" />
      </div>
    </li>
  </ul>
</template>

<script>
import FileThumbnail from "./FileThumbnail.vue";

export default {
  name: "PhotosGallery",
  components: {
    FileThumbnail
  },
  props: ["files"]
};
</script>

<style lang="scss">
.photos-gallery {
  margin: 0;
  padding: 0;
  li {
    display: inline-block;
    list-style: none;
    margin-right: 15px;
    margin-bottom: 15px;
    vertical-align: top;
  }
}
</style>
